import React, {CSSProperties, HTMLAttributes} from 'react'

import Colors from '@utils/Colors.js'

import {badgeStyle, BadgeVariant, getBadgeBackground} from './styles.js'

interface BadgeProps extends HTMLAttributes<HTMLDivElement> {
    size?: 'sm' | 'md'
    /** No variant is neutral (grey) */
    variant?: BadgeVariant | ''
    /** Background instead of the variant's */
    color?: string
    /** Text colour instead of dark, or light on a dark background */
    textColor?: string
}

/** A small pill with a status colour around a short text. Rest props go to the <div>. */
export default function Badge({size = 'md', children, style, variant, color, textColor, ...rest}: BadgeProps) {
    const background = color || getBadgeBackground(variant)

    const defaultStyle: CSSProperties = {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        paddingLeft: badgeStyle.paddingX,
        paddingRight: badgeStyle.paddingX,
        height: badgeStyle.height[size === 'sm' ? 'sm' : 'md'],
        width: 'fit-content',
        background,
        border: variant === 'white' ? `1px solid ${badgeStyle.border}` : 'none',
        color: textColor || (Colors.isDarkBackground(background) ? badgeStyle.textOnDark : badgeStyle.text),
        fontSize: badgeStyle.fontSize,
        borderRadius: badgeStyle.radius,
        ...style
    }

    return (
        <div {...rest} style={defaultStyle}>
            {children}
        </div>
    )
}
